module.exports = __webpack_public_path__ + "img/post_2.a0665b3a.jpg";